import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Type } from '@nerdwallet/currency';
import Box from '@nerdwallet/react-box';
import EditIcon from '@nerdwallet/react-icon/material/Edit';
import classes from '@nerdwallet/base-styles/classes';
import { formMoveToPage } from '@nerdwallet/nw-client-lib/lib/tracking';
import styles from './input-screen.module.less';

var InputScreen = function InputScreen(_ref) {
  var _ref$pastQuestion = _ref.pastQuestion,
      pastQuestionText = _ref$pastQuestion.text,
      pastQuestionClick = _ref$pastQuestion.onClick,
      tracking = _ref.tracking,
      headerText = _ref.headerText,
      headline = _ref.headline,
      helperText = _ref.helperText,
      children = _ref.children;

  var handlePastQuestionClick = function handlePastQuestionClick() {
    // this is based on the event schema under FormInteractionEvent on the following link
    // https://nerdwallet.atlassian.net/wiki/spaces/ENG/pages/7143947/Event+Schemas
    formMoveToPage({
      formName: tracking.formName,
      fieldValue: 'backQuestion',
      fieldName: tracking.fieldName
    });
    pastQuestionClick();
  };

  return /*#__PURE__*/React.createElement(Fragment, null, pastQuestionText && /*#__PURE__*/React.createElement(Box, {
    wide: {
      columns: 7,
      noGutter: 'both'
    },
    small: {
      columns: 3
    }
  }, /*#__PURE__*/React.createElement(Type, {
    className: styles.pastQuestion,
    size: 3,
    color: "neutral-dark",
    chronicle: true,
    onClick: handlePastQuestionClick
  }, pastQuestionText, /*#__PURE__*/React.createElement(EditIcon, {
    className: styles.editIcon
  }))), /*#__PURE__*/React.createElement(Box, {
    wide: {
      columns: 7,
      noGutter: 'both'
    },
    small: {
      columns: 4
    }
  }, headerText && /*#__PURE__*/React.createElement(Type, {
    size: 2,
    className: classes('margin-bottom-2')
  }, headerText)), /*#__PURE__*/React.createElement(Box, {
    wide: {
      columns: 8,
      noGutter: 'both',
      direction: 'column'
    },
    small: {
      columns: 4,
      direction: 'column'
    }
  }, headline, helperText && /*#__PURE__*/React.createElement("div", {
    className: classes('margin-top-2')
  }, helperText)), children);
};

InputScreen.displayName = 'InputScreen';
InputScreen.propTypes = {
  /** previous question that will be NDS color netural dark (lighter than black) */
  pastQuestion: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func
  }),
  tracking: PropTypes.shape({
    /** the name of the form this field is being used in, will be sent as a tracking parameter */
    formName: PropTypes.string.isRequired,

    /** the name of this field, will be sent as a tracking parameter */
    fieldName: PropTypes.string.isRequired
  }).isRequired,

  /** header text that is put above the headline */
  headerText: PropTypes.string,

  /** The question */
  headline: PropTypes.node.isRequired,

  /** helper text that is put below the headline */
  helperText: PropTypes.node,

  /** optional node that goes below the question (e.g cards to be selected) */
  children: PropTypes.node
};
InputScreen.defaultProps = {
  pastQuestion: {
    text: '',
    onClick: function onClick() {}
  },
  headerText: null,
  helperText: null,
  children: null
};
export default InputScreen;